var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMapRoute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.42.97L23 9.564a3.43 3.43 0 010 4.84l-8.58 8.594A3.39 3.39 0 0112.005 24c-.913 0-1.771-.357-2.417-1.002l-8.58-8.594a1.13 1.13 0 01-.074-.083c-.696-.873-1.028-1.93-.91-2.901a2.858 2.858 0 011.024-1.897L9.588.97c1.29-1.293 3.544-1.293 4.832 0zm-3.418 1.416l-8.58 8.594a1.12 1.12 0 01-.096.085.841.841 0 00-.317.594c-.051.422.119.931.456 1.371l8.537 8.551c.535.536 1.47.536 2.005 0l8.58-8.593a1.423 1.423 0 000-2.008l-8.58-8.594c-.535-.537-1.47-.536-2.005 0zm3.71 5.873l2.999 3a.999.999 0 010 1.414l-3 3a.997.997 0 01-1.413 0 .999.999 0 010-1.414l1.291-1.294H9.021l-.016 2a1 1 0 11-2 0v-1.982c0-1.112.904-2.017 2.016-2.017h5.568l-1.291-1.293a.999.999 0 111.413-1.414z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconMapRoute;